export const NOTIFICATION_CENTER_VISIBILITY = Object.freeze({
  MINE: "mine",
  ALL: "all",
});

export const NOTIFICATION_CENTER_DEADLINES_SCOPE = Object.freeze({
  NEXT_3_DAYS: "next_3_days",
  FORTHCOMING: "forthcoming",
  ALL: "all",
  MISSED: "missed",
});

/** GET /notify/notification_center/reporting?declaration_type= */
export const NOTIFICATION_CENTER_DECLARATION_TYPE = Object.freeze({
  ALL: "all",
  DECLARATION: "declaration",
  SALES_TAX_RETURN: "sales_tax_return",
  EPR_REPORT: "epr_report",
});

export const NOTIFICATION_CENTER_INTERMEDIARY_PAYMENTS_ACTION_REQUIRED_FILTER =
  Object.freeze({
    ACTION_REQUIRED: "action_required",
    HISTORY: "history",
    ALL: "all",
  });

export const NOTIFICATION_CENTER_INTERMEDIARY_PAYMENTS_IS_READ_FILTER =
  Object.freeze({
    ALL: "all",
    UNREAD: "unread",
  });
